import {mount} from 'svelte';

import InitializeLayout from '@js/layout';

import SearchIndex from '@js/components/search/SearchIndex.svelte';

InitializeLayout();

const target = document.getElementById('search-component');

const filters = JSON.parse(target.getAttribute('data-filters') || {});

mount(SearchIndex, {target: target, props: {allFilters: filters}});
